//@flow
import React from 'react';
import { styled } from 'linaria/react';
import { createComponent } from 'effector-react';
import { createApi, createStore, Store } from 'effector';
import { LogsView } from '../logs/view';
import { TabHeaderList } from '../tabs/styled';
const tab: Store<'console'> = createStore('console');
const api = createApi(tab, {
  showConsole: () => 'console'
});
const Tab =
/*#__PURE__*/
styled("li")({
  name: "Tab",
  class: "tdfaycm",
  vars: {
    "tdfaycm-0": [({
      isActive
    }) => isActive ? 'white' : 'inherit'],
    "tdfaycm-1": [({
      isActive
    }) => isActive ? '1px solid #fff' : 'none'],
    "tdfaycm-2": [({
      isActive
    }) => isActive ? '-1px' : '0']
  }
});
const TabContent =
/*#__PURE__*/
styled("div")({
  name: "TabContent",
  class: "t1olaarr"
});
const TabView = createComponent(tab, ({}, tab) => <TabContent>{tab === 'console' && <LogsView />}</TabContent>);
const ToolbarView = createComponent(tab, ({}, tab) => <TabHeaderList>
    <Tab onClick={api.showConsole} isActive={tab === 'console'}>
      Console
    </Tab>
  </TabHeaderList>);
const SecondanaryTabs =
/*#__PURE__*/
styled("div")({
  name: "SecondanaryTabs",
  class: "s1mi8gx5"
});
export default function () {
  return <SecondanaryTabs>
      <ToolbarView />
      <TabView />
    </SecondanaryTabs>;
}